// Shared by the ticket list, filters, summary, card and chat.

export const TICKET_STATUSES = [
  "new",
  "inProgress",
  "completed",
  "rejected",
  "incompleteData",
  "pending",
  "support",
];

export const TICKET_STAGES = ["team", "client", "app", "manager", "integration"];

export const formatTicketDate = (date) => {
  if (!date) return "";
  return new Date(date).toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

// senderId / createdBy come back either populated ({ _id, name }) or as a raw id.
export const getRefId = (ref) =>
  ref && typeof ref === "object" ? ref._id : ref;
